const it = {
  // Navigation
  nav_home: "Casa",
  nav_explore: "Esplorare",
  nav_workspace: "Spazio di lavoro",
  ws_videos: "video",
  ws_untitled: "Video senza titolo",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Il video non è riuscito",
  ws_failed_refunded: "Il tuo credito è stato restituito",
  ws_failed_dismiss: "Congedare",
  ws_failed_retry: "Riprova",
  ws_failed_retrying: "Di partenza…",
  ws_failed_banner_one: "Impossibile generare un video",
  ws_failed_banner_many: "{n} video non riusciti",
  ws_failed_banner_body: "Non è stato addebitato nulla: il credito è tornato sul tuo account. Riprova o scegli un argomento diverso.",
  ws_empty_title: "Niente qui ancora.",
  ws_empty_body: "Ogni video che realizzi apparirà qui, prima il più recente.",
  ws_generate: "Generare",
  ws_composer_placeholder: "Descrivi una lezione\u2026",
  ws_placeholder_hw: "Assegna un nome al compito... (facoltativo)",
  ws_placeholder_lecture: "Assegna un nome alla lezione... (facoltativo)",
  ws_placeholder_self_study: "Cosa vuoi studiare?",
  nav_search: "Cerca video...",
  nav_search_yours: "Cerca i tuoi video...",
  nav_notifications: "Notifiche",
  nav_mark_all_read: "Segna tutto letto",
  nav_no_notifications: "Nessuna notifica ancora",
  nav_no_notifications_sub: "Ti avviseremo quando i tuoi video saranno pronti",
  nav_upgrade: "Aggiornamento",
  nav_billing: "Fatturazione",
  nav_settings: "Impostazioni",
  nav_contact: "Contattaci",
  nav_api: "API",
  nav_sign_out: "disconnessione",
  nav_just_now: "Proprio adesso",
  nav_minutes_ago: "{n}m fa",
  nav_hours_ago: "{n}h fa",
  nav_days_ago: "{n}d fa",
  nav_used_this_month: "{used} di {cap} utilizzati questo mese",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} di {limit} utilizzati questa settimana",
  nav_free_daily: "4 video gratuiti a settimana",
  // Settings
  settings_title: "Impostazioni",
  settings_profile: "Profilo",
  settings_change_avatar: "Cambia avatar",
  settings_cancel: "Cancellare",
  settings_choose_wizard: "Scegli il tuo mago",
  settings_display_name: "Nome da visualizzare",
  settings_your_name: "Il tuo nome",
  settings_save: "Salva",
  settings_saving: "Risparmio...",
  settings_saved: "Salvato",
  settings_save_failed: "Impossibile salvare",
  settings_email: "E-mail",
  settings_notifications: "Notifiche",
  settings_email_notif: "Notifiche e-mail",
  settings_email_notif_desc: "Ricevi aggiornamenti e annunci via e-mail",
  settings_language: "Lingua",
  settings_language_desc: "Scegli la lingua per l'app e la narrazione video",
  settings_data_title: "I tuoi dati",
  settings_data_desc: "Scarica una copia dei dati personali associati al tuo account, inclusi profilo, video, corsi, sessioni e messaggi di supporto. I log di sistema interni e i dati di elaborazione derivati ​​non sono inclusi.",
  settings_data_download: "Scarica i miei dati",
  settings_data_exporting: "Preparazione…",
  settings_danger: "Zona pericolosa",
  settings_delete_account: "Elimina account",
  settings_delete_desc: "Elimina definitivamente il tuo account e tutti i dati associati. Questa azione non può essere annullata.",
  settings_delete_confirm: "Ciò eliminerà definitivamente il tuo account e tutti i tuoi dati. Digita {keyword} per confermare.",
  settings_delete_placeholder: "Digitare \"ELIMINA\" per confermare",
  settings_permanently_delete: "Elimina definitivamente",
  settings_deleting: "Eliminazione...",
  explore_watch_now: "Guarda ora",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Nessuna anteprima",
  explore_no_videos: "Nessun video ancora disponibile. Ricontrolla presto!",
  explore_featured_courses: "Corsi in primo piano",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Torna a Esplora",
  course_not_found: "Questo corso non è disponibile",
  // Home Page
  home_hero: "Impara qualsiasi cosa,",
  home_hero_accent: "visivamente",
  home_placeholder: "Cosa vuoi imparare o risolvere?",
  home_extracting: "Estrazione delle domande...",
  home_videos_generated: "Verranno generati {n, plural, one {# video} other {# video}}",
  home_credits: "{n, plural, one {# credito} other {# crediti}}",
  home_remaining: "rimanente questo mese",
  home_enter_prompt: "Inserisci ciò che desideri imparare o risolvere",
  home_popular: "Lezioni popolari",
  home_from_community: "Dalla comunità",
  home_community_sub: "Guarda cosa stanno creando gli studenti",
  home_tips_label: "Dal mago Magi",
  home_tips_title: "Suggerimenti e trucchi",
  home_tip1_title: "Diventa specifico",
  home_tip1_desc: "Non digitare un intero argomento. Scegli un'idea, un concetto, una domanda.",
  home_tip1_example: "Come funziona la replicazione del DNA nelle cellule eucariotiche",
  home_tip2_title: "Di' per chi è",
  home_tip2_desc: "Una spiegazione della scuola media sembra completamente diversa da una lezione universitaria.",
  home_tip2_example: "Spiegare le derivate a qualcuno che ha appena imparato l'algebra",
  home_tip3_title: "Di' a Magi quello che vuoi",
  home_tip3_desc: "Esempi, applicazioni dettagliate e nel mondo reale: basta dirlo e Magi seguirà.",
  home_tip3_example: "Il ciclo dell'acqua con esempi reali e una sintesi",
  home_tip_try: "Prova qualcosa del genere",
  home_proven_social: "Seguici su Instagram",
  home_ig_desc_1: "Sopra",
  home_ig_followers: "55.000 follower",
  home_ig_desc_2: "guarda i nostri video di matematica e scienze su Instagram ogni giorno. Questi mulinelli sono realizzati con lo stesso motore che usi qui.",
  home_view_profile: "Visualizza profilo",
  home_subscribe_now: "Iscriviti ora",
  home_sub_monthly: "Mensile",
  home_sub_yearly: "Annuale",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Risparmia il {pct}%",
  home_sub_per_month: "/ mese",
  home_sub_billed_monthly: "fatturato ${amount} ogni mese",
  home_sub_processing: "Elaborazione...",
  home_sub_no_commitment: "Nessun impegno. Annulla in qualsiasi momento.",
  home_sub_secured: "Protetto da Stripe",
  home_sub_headline: "Sblocca di più con {plan}",
  home_sub_due_now: "Scadenza adesso",
  home_sub_trial_label: "Accesso completo per {days} giorni",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Ti verranno addebitati ${amount} oggi per {n} video questo mese. Il giorno {date} si rinnova a ${amount}/mese a meno che non lo annulli prima: annulla in qualsiasi momento dalla fatturazione.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Ti verranno addebitati ${trial} oggi per {days} giorni di accesso completo, limitato a {n} video. La prova non continua con ${trial}: il {date} diventa automaticamente {planName} a ${plan} al mese (video {full}) e successivamente ${plan} verrà addebitato ogni mese fino all'annullamento. Annulla in qualsiasi momento dalla fatturazione.",
  home_sub_card: "Carta di credito o debito",
  home_sub_billed_once_yearly: "fatturato ${amount} una volta all'anno",
  home_sub_billed_trial: "fatturato ${amount} per {days} giorni, poi si rinnova alle ${renews} ogni mese",
  home_sub_switch_plan: "Cerchi invece {plan}?",
  home_sub_replaces_plan: "Sostituisce il tuo piano {plan}. La data di fatturazione rimane la stessa: lo spostamento verso l'alto comporta la differenza adesso, lo spostamento verso il basso inizia al rinnovo successivo.",
  home_sub_change_now: "Ora sei su {plan} — addebitati {amount} per la differenza.",
  home_sub_change_later: "Passerai a {plan} il {date}. Oggi non viene addebitato nulla.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} video al mese",
  // Pricing Page
  pricing_title: "Aggiorna il tuo piano",
  pricing_monthly: "Mensile",
  pricing_yearly: "Annuale",
  pricing_save: "Risparmia il 17%",
  pricing_best_value: "Miglior rapporto qualità/prezzo",
  pricing_your_plan: "Il tuo piano attuale",
  pricing_get_started: "Inizia",
  pricing_processing: "Elaborazione...",
  pricing_per_month: "/mese",
  pricing_billed_yearly: "Fatturato ${amount}/anno",
  pricing_videos_month: "{n, plural, one {# video} other {# video}}/mese",
  pricing_manage_cancel: "Gestisci o annulla",
  pricing_manage_unavailable: "Non abbiamo trovato un abbonamento da gestire. Contattaci e risolviamo.",
  pricing_opening: "Apertura...",
  billing_autorenew_monthly: "Si rinnova automaticamente a ${amount}/mese fino all'annullamento.",
  billing_autorenew_yearly: "Si rinnova automaticamente a ${amount}/anno fino all'annullamento.",
  billing_autorenews_on: "Rinnovo automatico il giorno {date} · annulla in qualsiasi momento",
  pricing_secured: "Protetto da Stripe",
  pricing_login_required: "Effettua il login per iscriverti",
  pricing_auth_error: "Errore di autenticazione dell'utente. Prova a uscire e rientrare.",
  pricing_feature_pdf: "PDF e estrazione di immagini",
  pricing_feature_quality: "Modello di qualità superiore",
  pricing_feature_speed: "Tempo di generazione più veloce",
  pricing_feature_study: "Sessioni di studio",
  pricing_free_hint: "Attualmente nel piano gratuito",
  // Billing Page
  billing_title: "Fatturazione",
  billing_current_plan: "Piano attuale",
  billing_payment_failed_title: "Il tuo piano è in pausa",
  billing_payment_failed_body: "Non siamo riusciti a riscuotere {amount}, quindi il tuo piano è in pausa. Aggiorna la tua carta per riavviarla: continueremo anche a riprovare.",
  billing_payment_failed_cta: "Sistema il pagamento",
  billing_change_plan: "Cambia piano",
  billing_invoices: "Fatture",
  billing_loading: "Caricamento fatture...",
  billing_no_invoices: "Ancora nessuna fattura",
  billing_date: "Data",
  billing_amount: "Quantità",
  billing_status: "Stato",
  billing_invoice: "Fattura",
  billing_view: "Visualizzazione",
  // Contact Page
  contact_title: "Contattaci",
  contact_placeholder: "Come possiamo aiutare?",
  contact_sent_desc: "Ti risponderemo il prima possibile.",
  contact_signin: "Accedi per contattare l'assistenza.",
  // Generation Queue
  queue_title: "Coda",
  queue_active: "{n} attivi",
  queue_generating: "{n} in generazione",
  queue_ready: "Pronto per guardare",
  queue_in_queue: "In attesa in coda...",
  queue_almost_ready: "Quasi pronto...",
  queue_seconds_left: "{n} sono rimasti",
  queue_minutes_left: "{m}m {s} restano",
  queue_watch_now: "Guarda ora",
  queue_waiting: "Aspettando in coda...",
  queue_empty: "Nessun video in coda",
  queue_empty_sub: "Genera un video per vederlo qui",
  queue_clear: "Cancella tutto",
  queue_total: "{n} totale",
  queue_first_time: "Il tuo video è in fase di generazione",
  queue_first_time_sub: "Di solito ~2 minuti. Quando sarà pronto sentirai un suono.",
  // Session Expired
  session_expired: "Sessione scaduta",
  session_expired_desc: "La tua sessione è scaduta per motivi di sicurezza. Accedi nuovamente per continuare.",
  // Cookie Banner
  cookie_text: "Utilizziamo i cookie per analizzare il traffico del sito e migliorare la tua esperienza. Per impostazione predefinita sono impostati solo i cookie essenziali.",
  cookie_learn_more: "Saperne di più",
  cookie_accept: "Accetta tutto",
  cookie_reject: "Rifiutare ciò che non è essenziale",
  // Create Project Modal
  create_new_project: "Nuovo progetto",
  create_extracting: "Estrazione...",
  create_select_problems: "Seleziona Problemi",
  create_select_topics: "Seleziona Argomenti",
  create_new_video: "Nuovo video",
  create_new_hw: "Nuovo progetto di compiti a casa",
  create_new_lecture: "Nuovo progetto di lezione",
  create_new_self_study: "Nuovo progetto",
  create_video: "Video",
  create_homework: "Compiti a casa",
  create_lecture: "Lezione",
  create_self_study: "Progetto",
  create_video_sub: "Genera un video",
  create_hw_sub: "Carica i compiti",
  create_lecture_sub: "Carica diapositive",
  create_self_study_sub: "Scegli i tuoi argomenti",
  create_video_prompt: "Cosa dovrebbe spiegare il video?",
  create_project_title: "Titolo del progetto",
  create_video_hint: "Questo verrà utilizzato sia come titolo che come suggerimento per il tuo video.",
  create_drop_hw: "Lascia qui i tuoi compiti",
  create_drop_lecture: "Lascia qui le diapositive della tua lezione",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Rilascia per iniziare un progetto",
  create_reading_hw: "Leggere i compiti",
  create_reading_lecture: "Leggendo la tua lezione",
  create_finding_problems: "Ricerca ed estrazione dei problemi...",
  create_finding_topics: "Estrazione argomenti...",
  create_add_video: "Aggiungi un altro video",
  create_add_more_files: "Aggiungi più file",
  create_starting: "Generazione iniziale...",
  create_generate_video: "Genera video \u00B7 1 credito",
  create_generate_n: "Genera {n, plural, one {# video} other {# video}} \u00B7 {n, plural, one {# credito} other {# crediti}}",
  create_create_project: "Crea progetto \u00B7 {n, plural, one {# credito} other {# crediti}}",
  create_no_problems: "Impossibile trovare alcun problema. Prova una foto più chiara o una pagina diversa.",
  create_no_topics: "Impossibile trovare argomenti. Prova una foto più chiara o un file diverso.",
  create_error: "Qualcosa è andato storto. Per favore riprova.",
  create_extract_daily_limit: "Questi sono tutti i documenti per oggi. Domani ne parleremo di più.",
  create_video_topic_placeholder: "Argomento del video {n}, ad es. \"Autovalori e autovettori\"",
  video_share: "Condividere",
  // and made the two indistinguishable.
  video_followup_placeholder: "Genera video di follow-up...",
  video_chip_simpler: "Spiega più semplice",
  video_chip_harder: "Esempio più difficile",
  video_chip_real_world: "Utilizzo nel mondo reale",
  // spends a credit generating a new one.
  video_ask_title: "Chiedi informazioni su questo video",
  video_ask_cta: "Parla di questo",
  video_ask_placeholder: "Fai una domanda...",
  video_ask_thinking: "Pensiero...",
  video_ask_close: "Vicino",
  video_ask_chip_explain: "Spiega quella parte",
  video_ask_chip_example: "Fai un esempio",
  video_ask_chip_why: "Perché funziona?",
  video_ask_limit_reached: "Hai raggiunto il limite di domande di oggi. Si resetta domani.",
  video_up_next: "Avanti",
  video_no_suggested: "Nessun video suggerito ancora",
  video_untitled: "Video senza titolo",
  video_created_recently: "Creato di recente",
  video_just_now: "Proprio adesso",
  video_minutes_ago: "{n, plural, one {# minuto} other {# minuti}} fa",
  video_hours_ago: "{n, plural, one {# ora} other {# ore}} fa",
  video_days_ago: "{n, plural, one {# giorno} other {# giorni}} fa",
  video_weeks_ago: "{n, plural, one {# settimana} other {# settimane}} fa",
  video_months_ago: "{n, plural, one {# mese} other {# mesi}} fa",
  video_years_ago: "{n, plural, one {# anno} other {# anni}} fa",
  video_unknown_date: "Data sconosciuta",
  video_download_error: "Qualcosa è andato storto. Per favore riprova.",
  // Search Results
  search_no_results: "Nessun risultato trovato",
  search_no_results_for: "Nessun risultato trovato per \"{query}\"",
  search_all_videos: "Cerca tutti i video",
  search_enter_term: "Inserisci un termine di ricerca per trovare i video",
  search_retry: "Riprova la ricerca",
  auth_continue_google: "Continua con Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Inizia subito il mio accesso. Capisco che ciò significa che rinuncio al mio diritto di recesso di {days} giorni e di ottenere un rimborso.",
  home_sub_waiver_required: "Per favore confermalo per continuare.",
  home_sub_agree_prefix: "Continuando accetti i ns",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Devi avere {age} o più per usare Magi.",
  auth_agree_prefix: "Effettuando l'accesso accetti i ns",
  auth_terms: "Termini di servizio",
  auth_and: "E",
  auth_privacy: "politica sulla riservatezza",
  auth_email_optin: "Inviami suggerimenti e aggiornamenti",
  // Auth modal (Google + email/password)
  auth_signin_title: "Accedi a Magi",
  auth_signin_desc: "Riprendi da dove avevi interrotto.",
  auth_signup_title: "Crea il tuo account",
  auth_signup_desc: "Inizio gratuito, nessuna carta necessaria.",
  auth_or: "O",
  auth_continue_email: "Continua con l'e-mail",
  auth_signing_in: "Accesso…",
  auth_working: "Solo un secondo...",
  auth_email_placeholder: "Indirizzo e-mail",
  auth_password_placeholder: "Password",
  auth_signin_submit: "Registrazione",
  auth_signup_submit: "Creare un account",
  auth_no_account: "Nuovo qui?",
  auth_signup_link: "Creare un account",
  auth_have_account: "Hai già un account?",
  auth_signin_link: "Registrazione",
  auth_forgot_password: "Hai dimenticato la password?",
  auth_reset_title: "Reimposta la tua password",
  auth_reset_desc: "Ti invieremo via email un collegamento per impostarne uno nuovo.",
  auth_reset_submit: "Invia collegamento di reimpostazione",
  auth_reset_sent: "Controlla la tua email per il collegamento di reimpostazione.",
  auth_back_to_signin: "Torna per accedere",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Conferma la tua email per continuare",
  verify_wall_desc: "Abbiamo inviato un link di conferma a {email}. Fare clic, quindi tornare qui.",
  verify_wall_check: "L'ho confermato",
  verify_wall_checking: "Controllo...",
  verify_wall_still_unverified: "Non ancora confermato. Fare clic sul collegamento nell'e-mail, quindi riprovare.",
  verify_wall_resend: "Invia nuovamente il collegamento",
  verify_wall_resent: "Inviato. Controlla la tua casella di posta e la cartella spam.",
  verify_wall_wrong_account: "Conto sbagliato? disconnessione",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Confermando la tua email",
  verify_action_working_desc: "Un momento.",
  verify_action_done_title: "È tutto a posto",
  verify_action_done_desc: "La tua email è confermata. Benvenuti a Magi.",
  verify_action_done_cta: "Inizia ad imparare",
  verify_action_failed_title: "Quel collegamento non ha funzionato",
  verify_action_failed_desc: "Potrebbe essere già stato utilizzato o essere scaduto. Torna indietro e mandatene uno nuovo.",
  verify_action_failed_cta: "Torna a Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Accedi per guardare",
  auth_watch_desc: "Crea un account gratuito per riprodurre questo video.",
  auth_watch_ready_title: "Il tuo video è pronto",
  auth_watch_ready_desc: "Accedi per guardarlo: verrà salvato sul tuo account.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Accedi per scaricare",
  auth_download_desc: "Crea un account gratuito per salvare questo video.",
  auth_ask_title: "Accedi per chiedere",
  auth_ask_desc: "Crea un account gratuito per chiedere informazioni su questo video.",
  auth_browse_title: "Accedi per navigare",
  auth_browse_desc: "Crea un account gratuito per esplorare ogni lezione.",
  auth_workspace_title: "Accedi per vedere il tuo lavoro",
  auth_workspace_desc: "Le tue lezioni e i tuoi progetti vivono nel tuo account.",
  auth_generate_title: "Accedi per continuare a creare",
  auth_generate_desc: "Gli account gratuiti ricevono un video ogni giorno.",
  video_restricted: "Questo video non è ancora disponibile.",
  // Share sheet
  share_title: "Condividi questo video",
  share_desc_mobile: "Pubblicalo nella tua storia, invialo a un amico o copia il collegamento.",
  share_desc_desktop: "Copia il collegamento o scarica il video da pubblicare dal tuo telefono.",
  share_to_apps: "Condividi su Instagram e altro",
  share_copy_link: "Copia collegamento",
  share_copied: "Collegamento copiato",
  share_download: "Scarica video",
  share_preparing: "Prepararlo…",
  share_watermark_note: "I video condivisi includono magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Benvenuti a Magi",
  welcome_subtitle: "Hai 4 video gratuiti per iniziare.",
  welcome_optin_reward: "+1 video gratuito",
  welcome_continue: "Continuare",
  age_gate_continue: "Continuare",
  age_gate_saving: "Risparmio...",
  // Landing Page
  landing_hero: "Digita un argomento.",
  landing_hero2: "Ottieni una lezione video.",
  landing_subtitle: "Magi trasforma qualsiasi soggetto in un video splendidamente animato e narrato in pochi minuti. Nessuna ripresa, nessun montaggio, nessuna competenza necessaria.",
  landing_signup_google: "Iscriviti con Google",
  landing_signing_in: "Accesso...",
  landing_chat_bubble: "In che modo il GPS utilizza la relatività?",
  landing_stats_title: "Scelto dagli studenti di tutto il mondo",
  landing_stat_videos: "3.000+",
  landing_stat_videos_desc: "Video generati",
  landing_stat_languages_desc: "Lingue",
  landing_stat_speed: "~1 minuto",
  landing_stat_speed_desc: "Tempo di generazione",
  landing_feature_lecture_title: "Rilascia gli appunti delle lezioni, scarica i video",
  landing_feature_lecture_desc: "Carica le tue diapositive o note. Magi estrae ogni argomento e genera una spiegazione video per ognuno.",
  landing_feature_hw_title: "Bloccato sui compiti? Caricalo.",
  landing_feature_hw_desc: "Rilascia una serie di problemi e Magi estrae ogni problema, quindi ti guida attraverso la soluzione in un video passo dopo passo.",
  landing_feature_chat_title: "Fai domande mentre guardi",
  landing_feature_chat_desc: "Ogni video viene fornito con un tutor AI con cui puoi chattare. Fai domande di follow-up, ottieni spiegazioni più approfondite o richiedi un nuovo video su una parte specifica che desideri comprendere meglio.",
  landing_feature_lang_title: "Impara nella tua lingua",
  landing_feature_lang_desc: "Magi genera video in inglese, spagnolo, hindi, cinese, giapponese e altro. Digita il tuo argomento in qualsiasi lingua e ricevi una lezione completamente narrata in quella lingua.",
  landing_cta_title: "Inizia ad imparare in pochi secondi",
  landing_cta_google: "Continua con Google",
  // Onboarding Bubbles
  onboarding_step1: "Questo non è un chatbot \u2014 digita un argomento e genererò una lezione video completa per te!",
  onboarding_step2: "Oppure trascina un PDF o una foto \u2014 Trasformerò ogni problema in una soluzione video passo dopo passo",
  onboarding_step3: "Premi Vai e il tuo video si unisce alla coda. Puoi continuare a navigare durante il rendering!",
  onboarding_generating: "Questa è la tua lezione da trarre in un paio di minuti. Continua a navigare se vuoi; atterrerà proprio qui quando sarà pronto.",
  onboarding_skip: "Saltare",
  onboarding_next: "Prossimo",
  onboarding_done: "Fatto!",
  // Generating Cards Row
  generating_label: "Generazione",
  // Lecture Session (Self Study)
  lecture_loading: "Caricamento...",
  lecture_fallback_title: "Lezione",
  lecture_building: "Creazione video...",
  lecture_building_time: "Di solito ci vogliono 2-4 minuti",
  lecture_failed: "La generazione del video non è riuscita",
  lecture_no_video: "Nessun video ancora",
  lecture_followup: "Seguito",
  lecture_now_playing: "Adesso sto giocando",
  lecture_tab_videos: "Video",
  lecture_tab_chat: "Chiacchierata",
  lecture_chat_empty: "Chiedi qualsiasi cosa su questo argomento",
  lecture_chat_chip1: "Spiega semplicemente",
  lecture_chat_chip2: "Fai un esempio",
  lecture_chat_chip3: "Perché è utile?",
  lecture_chat_placeholder: "Chiedi informazioni su questo argomento...",
  lecture_followup_placeholder: "Aggiungi un video di follow-up...",
  lecture_chat_error: "Mi spiace, non sono riuscito a elaborarlo. Riprova.",
  lecture_chat_generic_error: "Qualcosa è andato storto. Riprova.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "PDF dei compiti a casa",
  home_sc_hw_desc: "Carica una serie di problemi, ottieni un video funzionante per ogni domanda",
  home_sc_lecture_title: "PDF della lezione",
  home_sc_lecture_desc: "Trasforma diapositive o appunti in una serie di lezioni",
  home_sc_course_title: "Crea un corso",
  home_sc_course_desc: "Pianifica una sequenza di lezioni su un argomento",
  // Misc
  generic_error: "Qualcosa è andato storto. Per favore riprova.",
  loading: "Caricamento...",
};

export default it;
